import { render } from "./FilesView.vue?vue&type=template&id=6bff069a&scoped=true"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"

import "./FilesView.vue?vue&type=style&index=0&id=6bff069a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bff069a"]])

export default __exports__